import { DispatchCalendarAppointment } from './dispatch-planner-calendar.service';
import { DispatchStop, TourRouteLeg } from './dispatch-planner.component';

export type DispatchTeamId = number;

export interface TeamTourState {
  distance: string;
  duration: string;
  legs: TourRouteLeg[];
  path: { lat: number; lng: number }[];
}

export const EMPTY_TEAM_TOUR: TeamTourState = {
  distance: '',
  duration: '',
  legs: [],
  path: []
};

export interface PlannerTeam {
  id: DispatchTeamId;
  label: string;
  stops: DispatchStop[];
  teamBaseId: number | null;
  detailPanelVisible: boolean;
  tour: TeamTourState;
  calendarAppointments: DispatchCalendarAppointment[];
  tourCalculating: boolean;
}

export interface PlannerTeamColor {
  fill: string;
  stroke: string;
  css: string;
}

export const PLANNER_TEAM_COLORS: PlannerTeamColor[] = [
  { fill: '#2980b9', stroke: '#1f6391', css: '#2980b9' },
  { fill: '#d35400', stroke: '#a84300', css: '#d35400' },
  { fill: '#8e44ad', stroke: '#6c3483', css: '#8e44ad' },
  { fill: '#16a085', stroke: '#117a65', css: '#16a085' },
  { fill: '#c0392b', stroke: '#922b21', css: '#c0392b' },
  { fill: '#2c3e50', stroke: '#1a252f', css: '#2c3e50' },
  { fill: '#e67e22', stroke: '#ca6f1e', css: '#e67e22' },
  { fill: '#34495e', stroke: '#22303d', css: '#34495e' }
];

export function getPlannerTeamColor(teamIndex: number): PlannerTeamColor {
  return PLANNER_TEAM_COLORS[teamIndex % PLANNER_TEAM_COLORS.length];
}

export function createPlannerTeam(id: DispatchTeamId, label?: string): PlannerTeam {
  return {
    id,
    label: label || `Team ${id}`,
    stops: [],
    teamBaseId: null,
    detailPanelVisible: id <= 2,
    tour: { ...EMPTY_TEAM_TOUR },
    calendarAppointments: [],
    tourCalculating: false
  };
}

export function createDefaultPlannerTeams(): PlannerTeam[] {
  return [createPlannerTeam(1), createPlannerTeam(2)];
}

export function getTeamListId(teamId: DispatchTeamId): string {
  return `dispatchTeam${teamId}List`;
}

export function resolveTeamIdFromListId(listId: string, teams: PlannerTeam[]): DispatchTeamId | undefined {
  const match = /^dispatchTeam(\d+)List$/.exec(listId);
  if (!match) {
    return undefined;
  }
  const id = Number(match[1]);
  return teams.some(team => team.id === id) ? id : undefined;
}
